import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { getUpgradablePlans } from '~/modules/sales/services'
import { PaymentPlan } from '~/modules/sales/types'
import { personalTrainerSubscriptionOffersRoute } from '~/routes/routes'

import { UpgradeOffer } from './UpgradeOffer'

type Props = {
  planId: string
}

export const Upgrades: React.FC<Props> = ({ planId }) => {
  const [offers, setOffers] = useState<PaymentPlan[]>()

  useEffect(() => {
    const controller = new AbortController()
    if (planId) {
      getUpgradablePlans(planId, controller).then((o) => {
        o && setOffers(o)
      })
    }
    return () => {
      controller.abort()
    }
  }, [planId])

  return (
    <div className='flex flex-col gap-4'>
      {planId ? (
        <>
          <h1 className='font-bold text-2xl'>
            Precisa gerenciar mais alunos? Faça um upgrade!
          </h1>

          {offers && !offers.length ? (
            <p className='text-center border-t-[1px] border-t-slate-300/90 pt-2'>
              Sem ofertas de upgrade no momento.
            </p>
          ) : null}
          {offers?.map((o) => (
            <UpgradeOffer key={o.id} data={o} />
          ))}
        </>
      ) : (
        <>
          <div className='flex justify-between items-center'>
            <h4 className='font-semibold'>Assine um plano</h4>

            <Link
              to={personalTrainerSubscriptionOffersRoute}
              target='_blank'
              rel='noopener noreferrer'
              className='p-3 rounded-lg bg-gpa-blue-500
                hover:bg-gpa-blue-400 cursor-pointer text-white font-bold'
            >
              Ver planos
            </Link>
          </div>
        </>
      )}
    </div>
  )
}
